import { createContext, PropsWithChildren, useContext } from "react";

export interface CaptchaConfigContextStore {
  captchaSiteKey: string;
}

export const CaptchaConfigContext = createContext<CaptchaConfigContextStore | undefined>(undefined);

export const useCaptchaConfig = () => useContext(CaptchaConfigContext);

/*
 * Provides the captcha configuration to components that need it.
 * Expects server configuration in 'globalThis.serverConfig.captchaSiteKey'
 * If a context was already provided it's a noop
 */
export const CaptchaConfigProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const context = useContext(CaptchaConfigContext);

  // Check if config is available
  if (globalThis.serverConfig === undefined && context === undefined) {
    console.warn("CaptchaConfigProvider, no config is found. Context is not set. Noop");
  }

  const serverConfig = globalThis.serverConfig as CaptchaConfigContextStore | undefined;
  if (serverConfig?.captchaSiteKey) {
    const config: CaptchaConfigContextStore = {
      captchaSiteKey: serverConfig.captchaSiteKey,
    };

    return <CaptchaConfigContext.Provider value={config}>{children}</CaptchaConfigContext.Provider>;
  } else {
    return <>{children}</>;
  }
};
